// Módulo: Lançamento Mágico (Processamento de Texto Natural)
// Responsável por interpretar o texto digitado na "Magic Box" e preencher o formulário.

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.financeiro = window.FazendaRP.Pages.financeiro || {};

Object.assign(window.FazendaRP.Pages.financeiro, {
    parseMagicText: function (container) {
        const input = container.querySelector('#magic-input');
        if (!input || !input.value.trim()) return;

        const text = input.value.toLowerCase();
        let processedObs = input.value; // Texto original para salvar na obs

        console.log("Processando Magic Text:", text);

        // 1. Extrair Valor
        // Regex pega números que podem ter R$ na frente, e formatação BR ou US
        const valorRegex = /(?:r\$\s*)?(\d{1,3}(?:\.?\d{3})*(?:,\d{1,2})?|\d+(?:\.\d{1,2})?)/g;
        const matches = text.match(valorRegex);

        let valorEncontrado = 0;

        if (matches) {
            // Remove anos óbvios (ex: 2024, 2025) que parecem dinheiro
            const candidates = matches.map(m => {
                let raw = m.replace(/[^\d,]/g, '').replace(',', '.');
                if (m.includes(',')) {
                    raw = m.replace(/\./g, '').replace(',', '.');
                }
                return parseFloat(raw);
            }).filter(v => v < 1990 || v > 2100);

            if (candidates.length > 0) {
                valorEncontrado = Math.max(...candidates);
            }
        }

        // 2. Extrair Data (ontem, hoje, amanhã)
        let dataEncontrada = new Date();
        if (text.includes('ontem')) {
            dataEncontrada.setDate(dataEncontrada.getDate() - 1);
        } else if (text.includes('amanhã') || text.includes('amanha')) {
            dataEncontrada.setDate(dataEncontrada.getDate() + 1);
        }

        // 3. Extrair Máquina (Fuzzy Search na Frota)
        let maquinaId = null;
        let maquinaNome = '';
        if (this.maquinasCache) {
            for (const maq of this.maquinasCache) {
                const keywords = maq.nome.toLowerCase().split(' ');
                // Se o texto contém o nome exato ou placa
                if (text.includes(maq.nome.toLowerCase()) || (maq.placa && text.includes(maq.placa.toLowerCase()))) {
                    maquinaId = maq.id;
                    maquinaNome = maq.nome;
                    break;
                }
                // Tentativa fuzzy: primeira palavra com +4 letras
                if (keywords[0].length > 4 && text.includes(keywords[0])) {
                    maquinaId = maq.id;
                    maquinaNome = maq.nome;
                    break;
                }
            }
        }

        // 4. Extrair Categoria (Palavras-Chave)
        const catMap = {
            'diesel': 'Combustíveis',
            'gasolina': 'Combustíveis',
            'abastecimento': 'Combustíveis',
            'adubo': 'Insumos Agrícolas',
            'semente': 'Insumos Agrícolas',
            'mecanico': 'Manutenção',
            'peça': 'Manutenção',
            'pneu': 'Manutenção',
            'energia': 'Energia Elétrica',
            'luz': 'Energia Elétrica',
            'internet': 'Comunicação',
            'salario': 'Folha de Pagamento',
            'almoco': 'Alimentação',
            'mercado': 'Alimentação'
        };

        let categoriaEncontrada = '';
        for (const [key, val] of Object.entries(catMap)) {
            if (text.includes(key)) {
                categoriaEncontrada = val;
                break;
            }
        }

        // --- APLICAR NA UI ---

        // Valor
        if (valorEncontrado > 0) {
            const elValor = container.querySelector('#valor-total-sem-itens');
            if (elValor) elValor.value = valorEncontrado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }

        // Data
        const elData = container.querySelector('#data-emissao'); // E vencimento
        if (elData) {
            elData.valueAsDate = dataEncontrada;
            container.querySelector('#data-vencimento').valueAsDate = dataEncontrada;
        }

        // Obs
        const elObs = container.querySelector('#obs-lancamento');
        if (elObs) {
            let obsFinal = processedObs;
            if (maquinaNome) obsFinal += ` [Máquina: ${maquinaNome}]`;
            if (categoriaEncontrada) obsFinal += ` [Ref: ${categoriaEncontrada}]`;
            elObs.value = obsFinal;
        }

        // Feedback Visual
        const btn = container.querySelector('#btn-magic-process');
        if (btn) {
            const originalText = btn.innerHTML;
            btn.innerHTML = '<i class="fas fa-check"></i> Processado!';
            btn.style.background = '#d1fae5';
            btn.style.color = '#065f46';

            setTimeout(() => {
                btn.innerHTML = originalText;
                btn.style.background = 'white';
                btn.style.color = '#6d28d9';
            }, 2000);
        }

        window.FazendaRP.Toast.show('info', 'Magic Box', `Identificado: R$ ${valorEncontrado || '?'} | ${categoriaEncontrada || 'Genérico'} | ${maquinaNome || 'S/ Máq'}`);
    }
});
